// Meta Pixel utility functions
declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export const initMetaPixel = () => {
  // Check if already initialized
  if (window.fbq) return

  // Meta Pixel Code - Modified for React compatibility
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return

    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })

    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    // Create script element
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v

    // Append to head instead of inserting before existing script
    // This is more reliable in React apps
    const head = b.getElementsByTagName('head')[0]
    if (head) {
      head.appendChild(t)
    } else {
      // Fallback: append to body if head doesn't exist yet
      b.body?.appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  // Initialize with your Pixel ID
  window.fbq('init', '1904422326837040')

  // Track PageView
  window.fbq('track', 'PageView')

  console.log('Meta Pixel initialized successfully')
}

export const trackAddToCart = () => {
  if (window.fbq) {
    window.fbq('track', 'AddToCart')
    console.log('Meta Pixel: AddToCart event tracked')
  } else {
    console.warn('Meta Pixel not initialized yet')
  }
}

export const trackEvent = (eventName: string, params?: any) => {
  if (window.fbq) {
    window.fbq('track', eventName, params)
    console.log(`Meta Pixel: ${eventName} event tracked`, params)
  } else {
    console.warn('Meta Pixel not initialized yet')
  }
}
